import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Col, message, Row, Select, Spin, Switch, Upload } from 'antd';
import MessageConfirmModal from '../messageModal/MessageConfirmModal';
import InputComponent from '../input/InputComponent';
import DateComponent from '../date/DateComponent';
import HeaderCreateNewsComponent from '../header/HeaderCreateNewsComponent';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { TECHNICALS_CATEGORY_URL, TECHNICALS_URL } from '../../api/URLs';
import { getDataRequest, postDataRequest, putDataRequest } from '../../api/serviceMethods';
import SelectComponent from '../select/SelectComponent';
import DragViewMobileComponent from './DragViewMobileComponent';
import DragUploadComponent from '../upload/DragUploadComponent';
import OSSUploadWrapper from '../upload/OSSUploadWrapper';
import MobileViewTextDragComponent from './MobileViewTextDragComponent';
import InputNumberComponent from '../input/InputNumberComponent';
import TechnicalDragViewMobileComponent from './TechnicalDragViewMobileComponent';
import { formatDateSecondary } from '../../utils/dateFormatUtils';

function TechnologyUpload() {
    const { newStep } = useParams();
    const { i18n, t } = useTranslation();
    let condeLang = "cn"//i18n.language ? i18n.language : "cn"
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    let id = queryParams.get('id');
    const messageModalRef = useRef("");
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false)
    const dragViewMobileComponentRef = useRef("")
    const [dataObject, setDataObject] = useState({
        "title": "",
        "subtitle": "",
        "category" :"",
        "readingTime": "",
        "publishedAt": "",
        "expiryAt": "",
        "status": false,
        "isActive": false,
    });
    const [picUrl, setpicUrl] = useState([])
    const [optionsCategoryData] = useState([
        {
            _id: "技术展示",
            name: "技术展示",
            label: "技术展示",
            value: "技术展示",
        },
        {
            _id: "冷知识",
            name: "冷知识",
            label: "冷知识",
            value: "冷知识",
        },
    ]);

    const [datalocalize, setDatalocalize] = useState()

    // const getDataRequestAll = async (value) => {
    //     await getDataRequest(`${TECHNICALS_CATEGORY_URL}`, {}).then((res) => {
    //         if (res.status === 200) {
    //             let datas = res?.data ? res?.data.map((it, i) => ({
    //                 ...it,
    //                 name: it.name || "",
    //                 label: it.name || "",
    //                 value: it.name || ""
    //             })) : []
    //             setoptionsCategoryData(datas);
    //         }
    //     }).catch((err) => {
    //     });
    // }
    // useEffect(() => {
    //     getDataRequestAll()
    // }, [])

    const checktextByLang = (dataCode) => {
        let text = dataCode && dataCode[condeLang] && dataCode[condeLang].title ? dataCode[condeLang].title : ''
        const languages = dataCode ? Object.keys(dataCode) : []
        if (!text) {
            for (let lang of languages) {
                if (dataCode && dataCode[lang] && dataCode[lang].title) {
                    text = dataCode[lang].title;
                    break;
                }
            }
        }
        return text
    }
    const checktextByLangSub = (dataCode) => {
        let text = dataCode && dataCode[condeLang] && dataCode[condeLang].subtitle ? dataCode[condeLang].subtitle : ''
        const languages = dataCode ? Object.keys(dataCode) : []
        if (!text) {
            for (let lang of languages) {
                if (dataCode && dataCode[lang] && dataCode[lang].subtitle) {
                    text = dataCode[lang].subtitle;
                    break;
                }
            }
        }
        return text
    }

    const addNewValue = async (data) => {
        setDataObject(
            {
                ...data,
                "title": checktextByLang(data.localize),
                "subtitle": checktextByLangSub(data.localize),
                "expiryAt": data?.expiryAt || "",
                "publishedAt": data?.publishedAt || "",
                "category": data.category || "",
                "readingTime": data?.readingTime,
                "status": data?.status,
                "isActive": data?.isActive ? data?.isActive : false
            }
        )
        setpicUrl(data.coverimage ?
            [
                {
                    "uid": "1",
                    "name": data.coverimage && data.coverimage.fileName || "",
                    "status": "done",
                    "size": data.coverimage && data.coverimage.size || "",
                    "url": data.coverimage && data.coverimage.url || "",
                }
            ]
            : [])
        data && setDatalocalize(data)
    }
    const [isCanSubmit, setIsCanSubmit] = useState(true)
    const getDetailById = async () => {
        try {
            setLoading(true);
            await getDataRequest(`${TECHNICALS_URL}/${id && id}`)
                .then((res) => {
                    if (res.status === 200) {
                        addNewValue(res.data)
                    } else {
                        setIsCanSubmit(false)
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    setIsCanSubmit(false)
                    console.log(err);
                    setLoading(false);
                });
        } catch (error) {
            setIsCanSubmit(false)
            setLoading(false);
            message.error('Server Error!');
        }
    }
    useEffect(() => {
        if (id && id) { getDetailById() }
    }, [newStep]);

    const checkError = () => {
        if (
            // !picUrl ||
            !dataObject.title ||
            !dataObject.subtitle ||
            !dataObject.readingTime
        ) {
            return true
        }
        return false
    }
    
    const insertParams = () => {
        const memberPayload = {
            "coverimage": picUrl && picUrl.length > 0 ? picUrl[0].url : "",
            "coverimage": picUrl && picUrl.length > 0 ? {
                "url": picUrl && picUrl.length > 0 ? picUrl[0].url : "",
                "size": picUrl && picUrl.length > 0 ? picUrl[0].size : "",
                "fileName": picUrl && picUrl.length > 0 ? picUrl[0].name : "",
            } : "",
            "title": dataObject.title,
            "subtitle": dataObject.subtitle,
            "expiryAt": formatDateSecondary(new Date()),
            "publishedAt": formatDateSecondary(new Date()),
            "category": dataObject.category,
            "readingTime": dataObject?.readingTime,
            // "status": dataObject?.status,
            // "isActive": dataObject?.isActive ? dataObject?.isActive : false,
        }
        return memberPayload
    }

    const UpdatedParams = () => {
        const memberPayload = {
            "coverimage": picUrl && picUrl.length > 0 ? picUrl[0].url : "",
            "coverimage": picUrl && picUrl.length > 0 ? {
                "url": picUrl && picUrl.length > 0 ? picUrl[0].url : "",
                "size": picUrl && picUrl.length > 0 ? picUrl[0].size : "",
                "fileName": picUrl && picUrl.length > 0 ? picUrl[0].name : "",
            } : "",
            "title": dataObject.title,
            "subtitle": dataObject.subtitle,
            "expiryAt": formatDateSecondary(new Date()),
            "publishedAt": formatDateSecondary(new Date()),
            "category": dataObject.category,
            // "categoryId": dataObject.categoryId,
            "readingTime": dataObject?.readingTime,
            "status": dataObject?.status,
            "isActive": dataObject?.isActive ? dataObject?.isActive : false
        }
        return memberPayload
    }
    const handleSubmitNext = async () => {
        setIsSubmit(true)
        if (checkError()) {
            return false
        }
        setLoading(true);
        const memberPayload = insertParams()
        try {
            const res = await postDataRequest(TECHNICALS_URL, memberPayload);
            if (res?.status === 200) {
                let newsIdData = res.data.technicalsId ? res.data.technicalsId : ""
                navigate(`/technical-posts/upload/2?id=${newsIdData}`)
            } else {
                messageModalRef.current.showWarningConfirmsAutoClose(res.data?.message || res.message || t("An error occurred."), () => { }, "", true);
            }
            setLoading(false);
        } catch (err) {
            setLoading(false);
            messageModalRef.current.showWarningConfirmsAutoClose(err?.response?.data?.message || err?.message || "Server Error!", () => { }, "", true);
        } finally {
            setLoading(false);
            setIsSubmit(false);
        }
    }

    const hadleUpdateNext = async () => {
        setIsSubmit(true)
        if (checkError()) {
            return false
        }
        setLoading(true);
        const memberPayload = UpdatedParams()
        try {
            const res = await putDataRequest(`${TECHNICALS_URL}/${id}`, memberPayload);
            if (res?.status === 200) {
                navigate(`/technical-posts/upload/2?id=${id}`)
            } else {
                messageModalRef.current.showWarningConfirmsAutoClose(res.data?.message || res.message || t("An error occurred."), () => { }, "", true);
            }
            setLoading(false);
        } catch (err) {
            setLoading(false);
            messageModalRef.current.showWarningConfirmsAutoClose(err?.response?.data?.message || err?.message || "Server Error!", () => { }, "", true);
        } finally {
            setLoading(false);
            setIsSubmit(false);
        }
    }

    const hadleUpdate = async () => {
        dragViewMobileComponentRef.current.handleSubmitContent()
    }

    let setps = [
        {
            title: t('Basic information settings'),
            status: newStep - 0 > 1 ? "done" : "processing",
            stepCount: 1,
        },
        {
            title: t('Edit information content'),
            status: newStep - 0 === 2 ? "processing" : "toDo",
            stepCount: 2,
        },
    ]

    return (
        <>
            <HeaderCreateNewsComponent
                bntTitle={<>
                    <Button
                        className='b-danger'
                        disabled={loading || !isCanSubmit}
                        type="primary"
                        onClick={() => {
                            if (!newStep || newStep - 0 === 1) {
                                if (id) {
                                    hadleUpdateNext()
                                } else {
                                    handleSubmitNext()
                                }
                            } else {
                                hadleUpdate()
                            }
                        }}
                        style={{
                            fontSize: '16px',
                            backgroundColor: "#E50A47",
                            border: "1px solid #e72158",
                            color: "#FFFFFF",
                            opacity: loading || !isCanSubmit ? '0.4' : ""
                        }}
                        danger
                    >
                        {
                            newStep - 0 === setps.length ? t("SubmitNews") : t("Next step")
                        }
                    </Button>
                </>}
                isHide="view"
                newStep={newStep}
                setps={setps}
                onClick={() => {
                    navigate(newStep - 1 ? `/technical-posts/upload/${newStep - 1}?id=${id}` : `/technical-posts`)
                }}
                backTitle={t('Create Technology')}
            >
                <Spin spinning={loading}>
                    {
                        !newStep || newStep - 0 === 1 ? <div className='container newDetail'>
                            <Row className='mb-5'>
                                <Col md={4}>{t("Cover")} :</Col>
                                <Col md={20}>
                                    <Row className='w-100'>
                                        <Col md={24} sm={24}>
                                            <div className='w-100'>
                                                <OSSUploadWrapper
                                                    onUploadSuccess={(value) => {
                                                        setpicUrl([value])
                                                    }}
                                                >
                                                    <DragUploadComponent
                                                        fileList={picUrl ? picUrl : []}
                                                        setFileList={(values) => {
                                                            setpicUrl(values)
                                                        }}
                                                    />
                                                </OSSUploadWrapper>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className='mt-4 d-flex align-items-center'>
                                <Col md={4}>{t("News Title")} :</Col>
                                <Col md={20}>
                                    <InputComponent className={`mb-2`} status={isSubmit && !dataObject.title && `error`} value={dataObject.title}
                                        setValue={(value) => setDataObject({ ...dataObject, title: value })} placeholder="" />
                                </Col>
                            </Row>
                            <Row className='mt-4 d-flex align-items-center'>
                                <Col md={4}>{t("Description")} :</Col>
                                <Col md={20}>
                                    <InputComponent className={`mb-2`} status={isSubmit && !dataObject.subtitle && `error`} value={dataObject.subtitle}
                                        setValue={(value) => setDataObject({ ...dataObject, subtitle: value })} placeholder="" />
                                </Col>
                            </Row>
                            <Row className='mt-4 d-flex align-items-center'>
                                <Col md={4}>{t("Read Time")} :</Col>
                                <Col md={20}>
                                    <InputNumberComponent min={0} className={`mb-2`} status={isSubmit && !dataObject.readingTime && `error`} value={dataObject.readingTime}
                                        setValue={(value) => setDataObject({ ...dataObject, readingTime: value })} placeholder="" />
                                </Col>
                            </Row>
                            <Row className='mt-4 d-flex align-items-center'>
                                <Col md={4}>{t("Category")} :</Col>
                                <Col md={20}>
                                    <SelectComponent
                                        options={optionsCategoryData} value={dataObject.category}
                                        setValue={(value, values) => {
                                            setDataObject({
                                                ...dataObject,
                                                categoryId: values?._id,
                                                category: values?.name, // or values?.value
                                            });
                                        }}
                                        status={isSubmit && !dataObject.category && `error`}
                                        placeholder={``}
                                    />
                                </Col>
                            </Row>
                        </div>
                            :
                            <>
                                <div className='w-100 h-100' style={{ background: "rgb(241 241 241)" }}>
                                    <TechnicalDragViewMobileComponent
                                        ref={dragViewMobileComponentRef}
                                        datalocalize={datalocalize} setDatalocalize={setDatalocalize}
                                        loading={loading} setLoading={setLoading}
                                    />
                                    {/* <div className='mt-3 w-100 mb-3'>
                                        <MobileViewTextDragComponent data={datalocalize ? datalocalize : null}  />
                                    </div> */}
                                </div>
                                {/* <NewsPostCreateUpdatePage compose /> */}
                            </>
                    }
                    <MessageConfirmModal textCentered ref={messageModalRef} />
                </Spin>
            </HeaderCreateNewsComponent>
        </>
    );
}

export default TechnologyUpload;
